<template>
  <div class="pr-4" style="max-width: 250px;overflow-y: auto;overflow-x: hidden;">
    <div class="sideMenu-links">
      <div class="text-center" v-if="$store.state.responsive.viewDesktopFilters">
        <a class="navbar-brand" v-if="collapsed" href="#"><img alt="Vue logo" height="40" class="mt-3"
            src="../../../assets/symbol.png"></a>
        <a class="navbar-brand" v-else href="#" style="width: 250px !important;"><img alt="Vue logo" height="40" class="mt-3"
            src="../../../assets/logo.png"></a>
      </div>
      <div class="d-flex align-items-center justify-content-start ml-3 mt-3" v-else>
        <a href="#" id="menuIcon" aria-label="Menú hamburguesa" class="sideMenu-icon mt-1" @click="changeCollapse()">
          <v-icon name="oi-three-bars" scale="1.3" />
        </a>
        <a class="navbar-brand ml-4" href="#"><img alt="Vue logo" height="40"
            src="../../../assets/logo.png"></a>
      </div>
      <hr>
      <template v-if="$store.state.responsive.viewDesktopFilters">
        <ul class="nav flex-column nav-pills" v-bind:class="{ 'text-center': collapsed }">
          <li class="nav-item">
            <router-link class="nav-link px-1" :to="{ name: 'contratos' }">
              <span class="mr-3">
                <v-icon name="io-document-text" scale="1.2" title="Contratos" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Contratos</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link px-1" :to="{ name: 'clientes' }">
              <span class="mr-3">
                <v-icon name="fa-regular-user" scale="1.2" title="Clientes" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Clientes</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link px-1" :to="{ name: 'productos' }">
              <span class="mr-3">
                <v-icon name="fa-mobile-alt" scale="1.2" title="Productos" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Productos</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.roles.Backoffice_supervisor && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'riesgos' }">
              <span class="mr-3">
                <v-icon name="bi-exclamation-triangle" scale="1.2" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Tramos de riesgo</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.roles.Backoffice_Superadmin">
            <router-link class="nav-link px-1" :to="{ name: 'blackList' }">
              <span class="mr-3">
                <v-icon name="hi-clipboard-list" scale="1.2" title="Black List" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Black List</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_member) && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'gestionUsuarios' }">
              <span class="mr-3">
                <v-icon name="md-manageaccounts-outlined" scale="1.2" title="Gestión de usuarios" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Gestión de usuarios</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.roles.Backoffice_member && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'cancelaciones' }">
              <span class="mr-3">
                <v-icon name="md-cancel-outlined" scale="1.2" title="Cancelaciones" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Cancelaciones</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'promociones' }">
              <span class="mr-3">
                <v-icon name="bi-percent" scale="1.2" title="promociones" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Promociones</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'renovaciones' }">
              <span class="mr-3">
                <v-icon name="md-autorenew" scale="1.2" title="Renovaciones" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Renovaciones</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link px-1" :to="{ name: 'incidencias' }">
              <span class="mr-3">
                <v-icon name="io-document-text" scale="1.2" title="Incidencias" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Incidencias</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.roles.Backoffice_supervisor && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'estadisticas' }">
              <span class="mr-3">
                <v-icon name="ri-bar-chart-box-line" scale="1.2" title="Estadísticas" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Estadísticas</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin || $store.state.roles.Backoffice_Superadmin) && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'gestionEstados' }">
              <span class="mr-3">
                <v-icon name="md-timeline" scale="1.2" title="Gestión de Estados" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Gestión de Estados</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin || $store.state.roles.Backoffice_Superadmin) && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'operacionesCSV' }">
              <span class="mr-3">
                <v-icon name="bi-filetype-csv" scale="1.2" title="Operaciones CSV" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Operaciones CSV</span>
            </router-link>
          </li>
        </ul>
      </template>
      <template v-else>
        <ul class="nav flex-column nav-pills">
          <li class="nav-item">
            <router-link class="nav-link px-1" :to="{ name: 'contratos' }">
              <span class="mr-3">
                <v-icon name="io-document-text" scale="1.2" title="Contratos" />
              </span>
              <span class="nav-link__title">Contratos</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link px-1" :to="{ name: 'clientes' }">
              <span class="mr-3">
                <v-icon name="fa-regular-user" scale="1.2" title="Clientes" />
              </span>
              <span class="nav-link__title">Clientes</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link px-1" :to="{ name: 'productos' }">
              <span class="mr-3">
                <v-icon name="fa-mobile-alt" scale="1.2" title="Productos" />
              </span>
              <span class="nav-link__title">Productos</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.roles.Backoffice_supervisor && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'riesgos' }">
              <span class="mr-3">
                <v-icon name="bi-exclamation-triangle" scale="1.2" />
              </span>
              <span class="nav-link__title">Tramos de riesgo</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.roles.Backoffice_Superadmin">
            <router-link class="nav-link px-1" :to="{ name: 'blackList' }">
              <span class="mr-3">
                <v-icon name="hi-clipboard-list" scale="1.2" title="Black List" />
              </span>
              <span class="nav-link__title">Black List</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_member) && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'gestionUsuarios' }">
              <span class="mr-3">
                <v-icon name="md-manageaccounts-outlined" scale="1.2" title="Gestión de usuarios" />
              </span>
              <span class="nav-link__title">Gestión de usuarios</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.roles.Backoffice_member && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'cancelaciones' }">
              <span class="mr-3">
                <v-icon name="md-cancel-outlined" scale="1.2" title="Cancelaciones" />
              </span>
              <span class="nav-link__title">Cancelaciones</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'promociones' }">
              <span class="mr-3">
                <v-icon name="bi-percent" scale="1.2" title="promociones" />
              </span>
              <span class="nav-link__title" v-if="!collapsed">Promociones</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'renovaciones' }">
              <span class="mr-3">
                <v-icon name="md-autorenew" scale="1.2" title="Renovaciones" />
              </span>
              <span class="nav-link__title">Renovaciones</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link px-1" :to="{ name: 'incidencias' }">
              <span class="mr-3">
                <v-icon name="io-document-text" scale="1.2" title="Incidencias" />
              </span>
              <span class="nav-link__title">Incidencias</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="$store.state.roles.Backoffice_supervisor && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'estadisticas' }">
              <span class="mr-3">
                <v-icon name="ri-bar-chart-box-line" scale="1.2" title="Estadísticas" />
              </span>
              <span class="nav-link__title">Estadísticas</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin || $store.state.roles.Backoffice_Superadmin) && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'gestionEstados' }">
              <span class="mr-3">
                <v-icon name="md-timeline" scale="1.2" title="Gestión de Estados" />
              </span>
              <span class="nav-link__title">Gestión de Estados</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="($store.state.roles.Backoffice_supervisor || $store.state.roles.Backoffice_admin || $store.state.roles.Backoffice_Superadmin) && !$store.state.roles.Backoffice_member_empresas">
            <router-link class="nav-link px-1" :to="{ name: 'operacionesCSV' }">
              <span class="mr-3">
                <v-icon name="bi-filetype-csv" scale="1.2" title="Operaciones CSV" />
              </span>
              <span class="nav-link__title">Operaciones CSV</span>
            </router-link>
          </li>
        </ul>
      </template>
    </div>
    <div class="userInfo" v-if="!$store.state.responsive.viewDesktopFilters">
      <div class="px-1" v-if="channel && !$store.state.roles.Backoffice_member_empresas">
        <span>
          <v-icon class="mr-3" name="bi-globe" scale="1.2" :title="channel" />
          <span class="pl-2 mb-0">{{ channel }}</span>
        </span>
      </div>
      <div class="px-1" v-if="tenant">
        <span>
          <v-icon class="mr-3" name="fa-building" scale="1.2" :title="tenant" />
          <span class="pl-2 mb-0">{{ tenant }}</span>
        </span>
      </div>
      <div class="px-1" v-if="store">
        <span>
          <v-icon class="mr-3" name="fa-store" scale="1.2" :title="store" />
          <span class="pl-2 mb-0">{{ store }}</span>
        </span>
      </div>
      <div class="text-center position-relative dropdown-toggle userIcon px-1" id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <span class="mr-3">
          <v-icon class="userIcon-Pink" name="fa-user" scale="1.2" :title="username" />
        </span>
        <span class="pl-2 mb-0">
          {{ username }}
        </span>
        <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
          <span class="d-flex align-items-center">
            <a class="dropdown-item py-3 px-4" href="#" @click="changePassword();">
              <v-icon name="io-lock-closed-outline" class="mr-2" scale="1.2" />
              Cambiar contraseña
            </a>
          </span>
          <span class="d-flex align-items-center">
            <a class="dropdown-item py-3 px-4" href="#" @click="$logOut();">
              <v-icon name="co-exit-to-app" class="mr-2" scale="1.2" />
              Cerrar sesión
            </a>
          </span>
        </div>
      </div>
    </div>
    <div v-if="!collapsed" class="site-version" :class="{ 'desktop': $store.state.responsive.viewDesktopFilters }">
      {{ $siteVersion }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'SideNavigation',
  props: [
    'collapsed',
    'changeCollapse'
  ],
  data() {
    return {
      username: this.$cookies.get('username'),
      store: this.$cookies.get('store'),
      tenant: this.$cookies.get('tenant'),
      channel: this.$cookies.get('channel'),
    }
  },
  methods: {
    changePassword() {
      this.$router.push({ name: 'change-password' })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../scss/variables.scss';

.sideMenu-links {
  width: 100%;
}
.nav-link {
  color: white;
  background-color: rgb(51, 51, 48) !important;

  &__title {
    font-size: 1.143rem;
    padding-left: 8px;
  }
}

li {
  margin-bottom: 10px;
  margin-left: 10px;
}

.site-version {
  color: $white;
  position: relative;
  bottom: 15px;
  left: 15px;
  width: 100%;
  &.desktop {
    position: absolute;
  }
}

.userInfo {
  color: white;
  margin-bottom: 10px;
  margin-left: 10px;
  &>div {
    padding-bottom: 24px;
  }
  .userIcon {
    &-Pink {
      color: $primary;
    }
    &::after {
      display: none;
    }
  }
}.sideMenu-icon {
  color: white;
}
</style>